export const tabNames = {
  0: 'actions',
  1: 'automations',
};
